import {useAppSelector} from "../storage/hooks";
import {selectApps, selectGames} from "../storage/slicers/appSlice";
import { Row } from 'react-bootstrap';
import Card from "../components/Card";
import {APP, GAME} from "../storage/constants/properties";

function AllGames() {
    const games = useAppSelector(selectGames);

    return(
        <Row>
            {games.map((game) => (
                <Card id={game.id} type={GAME}/>
            ))}
        </Row>
    );
}

export default AllGames;